<mat-card>
  <app-card-header
    title="Asignar vehículo"
    [subtitle]="usuario?.usuario"
    icono="directions_car"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <section class="inputs-group">
      <ng-select
        [items]="vehiculos"
        [(ngModel)]="vehiculo"
        bindLabel="label"
        placeholder="Vehículo"
        style="width: 100%"
        [searchable]="true"
        appendTo="body"
        [virtualScroll]="true"
        notFoundText="No hay vehículos para este cliente"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>{{ item.label }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="ng-option-content">
            <strong>
              {{ item.identificacion || 'Sin identificación' }}
              @if (item.vehiculo?.patente) {
                · {{ item.vehiculo.patente }}
              }
            </strong>
            @if (item.vehiculo?.marca || item.vehiculo?.modelo) {
              <small class="ng-option-client">
                {{ item.vehiculo?.marca }} {{ item.vehiculo?.modelo }}
              </small>
            }
          </div>
        </ng-template>
      </ng-select>
    </section>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="close()">Cancelar</button>
    <button
      irxBoton="principal"
      type="button"
      (click)="asignarVehiculo()"
    >
      <mat-icon>check</mat-icon>
      Asignar
    </button>
  </mat-card-actions>
</mat-card>
